import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TableDataLayerReopen from "../components/TableDataLayerReopen";

const TableDataPageReopen = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* TableDataLayer */}
        <TableDataLayerReopen />
      </MasterLayout>
    </>
  );
};

export default TableDataPageReopen;
